import { render } from "./HrCriteria.vue?vue&type=template&id=eba765a2&scoped=true"
import script from "./HrCriteria.vue?vue&type=script&lang=ts"
export * from "./HrCriteria.vue?vue&type=script&lang=ts"

import "./HrCriteria.vue?vue&type=style&index=0&id=eba765a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eba765a2"

export default script